import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Music2, Heart, Mic2, Building2, Megaphone, Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

const ROLES = [
  { v: "public", l: "Fan / Visitor", d: "Discover events, RSVP, follow artists & venues.", Icon: Heart },
  { v: "artist", l: "Artist / Band", d: "Build an artist profile, set availability, bid on gigs.", Icon: Mic2 },
  { v: "venue", l: "Venue Owner", d: "List your venue, manage bookings, deals & menus.", Icon: Building2 },
  { v: "promoter", l: "Event Promoter", d: "Post events, manage RSVPs, and post gigs.", Icon: Megaphone },
];

export default function ChooseRole() {
  const { user, setUser } = useAuth();
  const nav = useNavigate();
  const [busy, setBusy] = useState("");

  const choose = async (role) => {
    setBusy(role);
    try {
      await api.patch("/auth/role", { role });
      if (user) setUser({ ...user, role });
      nav("/dashboard");
    } catch (e) { setBusy(""); }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-12" data-testid="choose-role-page">
      <div className="w-full max-w-2xl">
        <div className="flex items-center gap-2 mb-3 justify-center"><Music2 className="text-rose-500" /><span className="font-display font-extrabold text-xl">Gulf Coast VIP</span></div>
        <h1 className="font-display font-black text-3xl md:text-4xl text-center">How will you use Gulf Coast VIP?</h1>
        <p className="text-zinc-400 text-center mt-2 mb-8">Pick your role to set up the right dashboard. You can change this later.</p>
        <div className="grid sm:grid-cols-2 gap-4">
          {ROLES.map((r) => (
            <button key={r.v} onClick={() => choose(r.v)} disabled={!!busy} data-testid={`choose-role-${r.v}`}
              className="text-left bg-[#111] border border-white/10 rounded-2xl p-5 hover:border-rose-500/60 hover:bg-white/5 transition-colors disabled:opacity-50 group">
              <div className="flex items-center gap-3 mb-2">
                <span className="w-10 h-10 rounded-xl bg-rose-500/15 text-rose-300 flex items-center justify-center">
                  {busy === r.v ? <Loader2 size={18} className="animate-spin" /> : <r.Icon size={18} />}
                </span>
                <span className="font-display font-bold text-lg">{r.l}</span>
              </div>
              <p className="text-sm text-zinc-400">{r.d}</p>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
